import { Toast } from 'antd-mobile';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import api from '../../utils/DoRequest';
import * as apiConstants from '../../constants';
import { IM_USER_INFO } from '../../actions/imAction';
import { IMMobile } from '../IMPlatform';
import TopNav from '../Common/TopNav';
import MyTabBar from '../Common/TabBar';
import url from 'url';

const Wrapper = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: calc(100% - 48px - 1.1rem);
    flex: 1;
    z-index: 0;
    overflow: hidden;
    //top: -49px;
`;
const ImHeader = styled.div`
    width: 100%;
`;
const ImContianer = styled.div`
    width: 100%;
    height: 100%;
`;

class Information extends Component {
    constructor(props) {
        super(props);
        this.state = {
            icon: null,
            userId: null,
            pid: null,
            userName: null,
        };
    }

    componentDidMount() {
        this.getProfileInfo();
    }

    /**
     * 获取 uid pid
     * 13426150363
     */
    getProfileInfo = async () => {
        // const phone = window.requestHeaders().phonenum ? window.requestHeaders().phonenum : this.props.requestHeaders.phonenum;
        // this.props.saveMyPhoneNum && this.props.saveMyPhoneNum(phone);
        // this.props.fetchLawyerToken && this.props.fetchLawyerToken({phoneNum: phone});
        const { phone, token } = this.props;
        const httpUrl = this.props.location.search;
        const phoneNum = url.parse(httpUrl, true).query.phone;
        const hanukkahUserId = url.parse(httpUrl, true).query.hanukkahUserId;
        const email = url.parse(httpUrl, true).query.email;
        const _phoneNum = Number(phone ? phone : phoneNum);
        // const appVersion = url.parse(httpUrl, true).query.appVersion;
        // const res = await api.doGETRequest(`${apiConstants.TG_GET_LAWYER_DETAILS}?phoneNum=${Number(phone ? phone : phoneNum)}`);
        const res = await api.doGETRequest(
            `${apiConstants.TG_GET_LAWYER_DETAILS}?identifier=${_phoneNum ? _phoneNum : email}`
        );
        if (res.result && res.result.code === 0) {
            if (
                res.data &&
                res.data.name &&
                // res.data.profileId &&
                res.data.hanukkahUserId
            ) {
                const transform = {
                    icon: res.data.picUrl,
                    userId: res.data.hanukkahUserId,
                    pid: res.data.profileId,
                    userName: res.data.name,
                    token: res.data.token,
                    phonenum: phone,
                };

                this.setState(transform);

                this.props.updateUserInfo(transform);
            } else {
                const errorMessage = `身份信息获取失败`;
                Toast.fail(errorMessage);
                console.error(errorMessage);
            }
        } else {
            Toast.fail(res.message);
        }
        await api
            .doGETRequest(apiConstants.LOGIN, token)
            .then(res => {
                // todo
            })
            .catch(e => {
                const errorMessage = `身份信息获取失败`;
                Toast.fail(errorMessage);
                console.error(e);
            });
    };

    render() {
        const { userId, pid, userName, icon } = this.props.requestHeaders || {};
        return (
            <ImContianer>
                <ImHeader>
                    <TopNav title="无讼平台" />
                </ImHeader>
                <Wrapper>
                    {userId && userName ? (
                        <IMMobile
                            customComponent={null}
                            btnCustomComponent={null}
                            notificationCallback={num => console.log(`UNREAD MESSAGE COUNT: [${num}]`)}
                            switchSessionCallback={user => console.log(`USER INFO`, user)}
                            closeCallback={() => {
                                window.location = 'click:navigationback';
                            }}
                            userInfo={{
                                icon,
                                userId,
                                userName,
                                pid,
                            }}
                        />
                    ) : (
                        <div>加载中...</div>
                    )}
                </Wrapper>

                <MyTabBar />
            </ImContianer>
        );
    }
}

function updateUserInfo(data) {
    return dispatch => {
        dispatch({
            type: IM_USER_INFO,
            imUserInfo: data,
        });
    };
}

// appUserInfo:state.mine.appUserInfo 这个是获取uid，pid
const mapStateToProps = state => ({
    token: state.getPhoneToken.token,
    requestHeaders: state.imReducer,
    phone: state.getPhoneToken.phone,
});
export default connect(mapStateToProps, {
    updateUserInfo: updateUserInfo,
})(Information);
